export default class AccountLoginRegister {
  constructor(component) {
    this.dom = {
      $component: component,
      $btns: component.querySelectorAll('.js-accountLoginRegisterBtn')
    }
    this.state = {
      activeForm: 'login',
      activeFormClass: 'activeForm'
    }
    this.btnClickHandler = this.btnClick.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$btns.forEach($btn => $btn.addEventListener('click', this.btnClickHandler))
  }

  btnClick(e) {
    const {dom, state} = this
    const form = e.currentTarget.dataset.form

    if (state.activeForm === form) return

    const currentActiveButton = dom.$component.querySelector(`.js-accountLoginRegisterBtn[data-form="${state.activeForm}"]`)
    const currentActiveForm = dom.$component.querySelector(`.js-accountLoginRegisterFormWrap[data-form="${state.activeForm}"]`)
    const activeButton = e.currentTarget
    const activeForm = dom.$component.querySelector(`.js-accountLoginRegisterFormWrap[data-form="${form}"]`)

    currentActiveButton.setAttribute('aria-expanded', 'false')
    currentActiveButton.classList.remove(state.activeFormClass)
    currentActiveForm.classList.remove(state.activeFormClass)
    activeButton.setAttribute('aria-expanded', 'true')
    activeButton.classList.add(state.activeFormClass)
    activeForm.classList.add(state.activeFormClass)
    state.activeForm = form
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountLoginRegister = this
  }
}
